module.exports = __webpack_public_path__ + "static/media/8.4e24a6aa.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row5/8.wav
// module id = 92
// module chunks = 0